import { Component, OnInit } from '@angular/core';
import { MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
  selector: 'app-security-alert',
  templateUrl: './security-alert.component.html',
  styleUrls: ['./security-alert.component.scss']
})
export class SecurityAlertComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }



}
